import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import Validator from 'validatorjs';

import { FormControl } from '../../../../facturotopia';

class UsuarioPasswordForm extends Component {
  state = {}

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules)
    };
  }

  get rules() {
    return {
      old_password: ['required'],
      password: ['required', 'confirmed', 'min:8', 'password'],
      password_confirmation: ['required', 'min:8', 'password']
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.props.data,
      ...value
    }

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step: this.props.step,
      isValidForm: validator.passes()
    });
  }

  render() {
    const { data = {} } = this.props;
    const { validator } = this.state;

    return (
      <Form autoComplete="off">

        <FormControl type="password"
          label="Contraseña actual"
          name="old_password"
          placeholder=""
          help=""
          validator={ validator }
          value={ data.old_password }
          onChange={ this.handleOnChange }
        />

        <FormControl type="password"
          label="Nueva contraseña"
          name="password"
          placeholder=""
          help=""
          validator={ validator }
          value={ data.password }
          onChange={ this.handleOnChange }
        />

        <FormControl type="password"
          label="Confirmar nueva contraseña"
          name="password_confirmation"
          placeholder=""
          help=""
          validator={ validator }
          value={ data.password_confirmation }
          onChange={ this.handleOnChange }
        />

      </Form>
    )
  }
}

export default UsuarioPasswordForm;